export class Menu {
    constructor() {
        this.items = [];
    }
}